import { literal, TypeOf } from 'zod';

import { BaseProduct } from './base';
import { ProductType } from './types';

/* ----------------------------- Generic Product ---------------------------- */

export const GenericProduct = BaseProduct.extend({
    type: literal(ProductType.Generic),
});
export type GenericProduct = TypeOf<typeof GenericProduct>;
